<app-page-layout [alertLoading]="alertLoading" [alertSucesso]="alertSucesso" [alertError]="alertError">
  <h1 class="titulo">Contatos</h1>
  <p class="paragrafo mb-4">Inclua um novo contato para sua empresa</p>
  @if (formulario) {
    <form [formGroup]="formulario" class="col-12 mt-4 ps-0">
      <div class="row">
        <div class="col-12 col-lg-4 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptNomeCompleto">NOME COMPLETO</label>
            <input type="text" class="form-control" id="inptNomeCompleto" formControlName="nomeCompleto" placeholder="Preencha com o nome">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptCPF">CPF</label>
            <input type="text" class="form-control" id="inptCPF" formControlName="cpf" placeholder="Preencha com o CPF" mask="000.000.000-00">
            @if (formControl.cpf.invalid && (formControl.cpf.dirty || formControl.cpf.touched)) {
              <div class="alert alert-danger">
                @if (formControl.cpf.errors?.required) {
                  <div>Campo obrigatório</div>
                }
                @if (formControl.cpf.errors?.cpfValidator) {
                  <div>CPF inválido</div>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="slctGenero">GÊNERO</label>
            <app-select
              [form]="formulario"
              name="genero"
              id="slctGenero"
              [options]="[{ description : 'Masculino' , value : 'M'}, { description : 'Feminino' , value : 'F'}]"
              optionValue="value"
              optionText="description">
            </app-select>
          </div>
        </div>
        <div class="col-12 col-md-6 col-md-6 col-lg-4 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptDataNasc">DATA DE NASCIMENTO</label>
            <input class="form-control d-inline m-0" id="inptDataNasc" dateMask [matDatepicker]="picker1" placeholder="dd/mm/aaaa" formControlName="dataNascimento" (blur)='validadata()'>
            <mat-datepicker-toggle matSuffix [for]="picker1" class="datepicker-custom-float"></mat-datepicker-toggle>
            <mat-datepicker #picker1 (closed)="validadata()"></mat-datepicker>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptEmail">E-MAIL</label>
            <input type="email" class="form-control" id="inptEmail" formControlName="email" placeholder="Preencha com o e-mail">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptTelefone">TELEFONE</label>
            <input type="text" class="form-control" id="inptTelefone" formControlName="telefone" mask="(00) 00000-0000" [dropSpecialCharacters]="true" [validation]="false" placeholder="Nº do telefone">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="mb-3">
            <label class="label-menor" for="inptRamal">RAMAL</label>
            <input type="number" (keypress)="somenteNumeros($event)" class="form-control" id="inptRamal" formControlName="ramal" placeholder="Nº Ramal">
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          @if (departamentos) {
            <div class="mb-3">
              <label class="label-menor" for="slctDepartamento">DEPARTAMENTO</label>
              <app-select
                [form]="formulario"
                name="departamento"
                id="slctDepartamento"
                [options]="departamentosOptions"
                defaultDescription="Selecionar departamento"
                optionValue="value"
                optionText="description">
              </app-select>
            </div>
          }
          @if (departamentos === null) {
            <div>
              <div class="text-center">
                <output>
                  <div class="spinner-border c-primary">
                    <span class="visually-hidden">Consultando departamentos ...</span>
                  </div>
                </output>
              </div>
              <p class="legenda-spinner">Consultando departamentos ...</p>
            </div>
          }
          @if (departamentos === false) {
            <div><p class="legenda-erro">Erro ao consultar departamentos</p></div>
          }
        </div>
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          @if (cargos) {
            <div class="mb-3">
              <label class="label-menor" for="slctCargo">CARGO</label>
              <app-select
                [form]="formulario"
                name="cargo"
                id="slctCargo"
                [options]="cargosOptions"
                defaultDescription="Selecionar cargo"
                optionValue="value"
                optionText="description">
              </app-select>
            </div>
          }
          @if (cargos === null) {
            <div>
              <div class="text-center">
                <output>
                  <div class="spinner-border c-primary">
                    <span class="visually-hidden">Consultando cargos ...</span>
                  </div>
                </output>
              </div>
              <p class="legenda-spinner">Consultando cargos ...</p>
            </div>
          }
          @if (cargos === false) {
            <div><p class="legenda-erro">Erro ao consultar cargos</p></div>
          }
        </div>
      </div>
    </form>
  }

  @if (mensagemErro) {
    <p class="legenda-erro mt-2 mb-4">{{mensagemErro}}</p>
  }

  <div class="w-100 d-flex justify-content-start mt-3">
    <button class="botao-outline" id="btnFechar" (click)="voltarAbaContatos()">CANCELAR</button>
    <button class="botao ms-auto" id="btnSalvar" (click)="adicionarContato()" [ngClass]="{ 'disabled': !formulario.valid || dataValidator === false }" [disabled]="!formulario.valid || dataValidator === false" data-bs-toggle="tooltip" data-placement="top" title="Preencha todos os campos obrigatórios.">SALVAR</button>
  </div>
</app-page-layout>
